// 该文件负责所有的公共组件的全局注册
// vue插件机制: Vue.use
import cfg from './constant'

export default {
    install (app) {
        app.config.globalProperties.$cfg = cfg;
    }
}